export default {"src":"https://dap-prod-3m8r9mc2a-dap-rewrite.vercel.app/_next/static/media/MyprofileChevronRight.b33c9c98.svg","height":49,"width":48};